import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { ArrowRight } from "lucide-react";

const MARQUEE_TEXT = "PUNTA CANA \u00a0\u00b7\u00a0 P\u00c1DEL \u00a0\u00b7\u00a0 COMMUNITY \u00a0\u00b7\u00a0 CREDENTIAL \u00a0\u00b7\u00a0 VERIFICATION \u00a0\u00b7\u00a0 ";

export default function Landing() {
  const { user, isAdmin, isMember } = useAuth();

  return (
    <div className="min-h-screen bg-lv-bg relative overflow-hidden" data-testid="landing-page">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-b from-walnut-deep/60 via-lv-bg/90 to-lv-bg" />
      </div>
      <div className="relative z-10 min-h-screen flex flex-col" style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}>
        {/* Header — wordmark only; authenticated users get a Dashboard link */}
        <header className="px-6 sm:px-8 pt-[max(1.5rem,env(safe-area-inset-top))] pb-6 flex items-center justify-between">
          <span className="font-serif text-xl sm:text-2xl text-cream tracking-[0.25em]" data-testid="landing-logo">LV PASS</span>
          {user && (
            <Link to={isAdmin ? "/admin/members" : isMember ? "/pass" : "/me"} className="lv-btn-primary inline-flex items-center gap-2 min-h-[44px]" data-testid="landing-dashboard-link">
              Dashboard <ArrowRight size={16} />
            </Link>
          )}
        </header>

        {/* Hero */}
        <div className="flex-1 flex flex-col items-center justify-center px-6 sm:px-8 text-center">
          <div className="animate-fade-in" style={{ animationDelay: "0.1s", opacity: 0 }}>
            <p className="text-xs sm:text-sm tracking-[0.4em] uppercase text-lv-muted mb-8">Los Viejevos P&aacute;del Society</p>
          </div>
          <div className="animate-fade-in" style={{ animationDelay: "0.3s", opacity: 0 }}>
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-cream tracking-tight leading-[1.1] mb-5">LV Pass</h1>
          </div>
          <div className="animate-fade-in" style={{ animationDelay: "0.5s", opacity: 0 }}>
            <p className="text-sm sm:text-base text-lv-muted max-w-xs sm:max-w-sm leading-relaxed tracking-wide">
              One Community.<br className="sm:hidden" />{" "}Belonging, wherever the game takes&nbsp;you.
            </p>
          </div>
          <div className="animate-fade-in mt-12" style={{ animationDelay: "0.7s", opacity: 0 }}>
            {!user && (
              <Link to="/auth/sign-in" className="lv-btn-primary inline-flex items-center gap-3 px-8 sm:px-10 py-4 text-sm sm:text-base min-h-[48px]" data-testid="landing-cta">
                Sign In <ArrowRight size={18} />
              </Link>
            )}
          </div>
        </div>

        {/* Marquee footer — stays above Safari toolbar via safe-area padding on parent */}
        <div className="border-t border-lv-border overflow-hidden py-4 mb-[env(safe-area-inset-bottom,0px)]">
          <div className="lv-marquee-track animate-marquee">
            <span className="text-xs tracking-[0.5em] uppercase text-lv-muted/40 whitespace-nowrap">
              {MARQUEE_TEXT}{MARQUEE_TEXT}{MARQUEE_TEXT}{MARQUEE_TEXT}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
